import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PopupViewModel } from '../../view-models/modal/popup-view-model';

import { FieldsetModule } from 'primeng/fieldset';
import type { ModalComponentInterface } from '@nts/std/interfaces';

@Component({
    selector: 'nts-popup',
    templateUrl: 'popup-container.component.html',
    styleUrls: ['popup-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    FieldsetModule
]
})

export class PopupContainerComponent implements OnInit, ModalComponentInterface {
    viewModel: PopupViewModel;

    constructor() { }

    ngOnInit(): void {
    }
}
